module.exports = __webpack_public_path__ + "static/media/c02-01-4.f87a8f49.png";